export default __webpack_public_path__ + "static/media/alert-green.8836f2e2.svg";